import { Chip, Stack, Typography } from '@mui/material';
import { groups } from '@/constants';

/**
 * 수료 조건 표시 셀 컴포넌트
 * 
 * 그룹의 수료 조건 목록을 Chip으로 표시합니다.
 * 
 * @param {Object} props
 * @param {Object} props.row - 그리드 행 데이터
 */
const CompletionRequirementsCell = ({ row }) => {
    const requirements = row.completionRequirements || [];
    
    if (requirements.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                -
            </Typography>
        );
    }
    
    return (
        <div style={{ display: 'inline-flex', gap: 4, justifyContent: 'center', alignItems: 'center' }}>
            {requirements.map((req) => {
                const option = groups.COMPLETION_REQUIREMENTS_OPTIONS.find(opt => opt.value === req);
                return option ? (
                    <Chip
                        key={req}
                        label={option.label}
                        size="small"
                        color="secondary"
                        variant="outlined"
                        sx={{ fontSize: '0.7rem', height: 20 }}
                    />
                ) : (
                    <Chip
                        key={req}
                        label={req}
                        size="small"
                        color="default"
                        variant="outlined"
                        sx={{ fontSize: '0.7rem', height: 20 }}
                    />
                );
            })}
        </div>
    );
};

export default CompletionRequirementsCell;
